import api, { adminApiPrefix } from './Api';
import {
  BasketItem,
  basketItemFromResponse,
} from '../interfaces/Basket/BasketItem';
import {
  BasketOwnerFilter,
  basketOwnerFilterToParams,
} from '../interfaces/Basket/BasketOwnerFilter';
import { PaginatedResponse } from '../interfaces/PaginatedResponse';
import {
  BasketOwner,
  basketOwnerFromResponse,
} from '../interfaces/Basket/BasketOwner';

const basketAdminApiPrefix = `${adminApiPrefix}/basket`;

export const getUserBasket = async (userID: number): Promise<BasketItem[]> => {
  const response = await api.get(`${basketAdminApiPrefix}/${userID}`);

  return (response.data?.data ?? []).map((item: any) =>
    basketItemFromResponse(item),
  );
};

export const getBasketOwners = async (
  filter: BasketOwnerFilter,
): Promise<PaginatedResponse<BasketOwner>> => {
  const response = await api.get(basketAdminApiPrefix, {
    params: basketOwnerFilterToParams(filter),
  });

  return {
    data: (response.data?.data ?? []).map((owner: any) =>
      basketOwnerFromResponse(owner),
    ),
    totalCount: response.data?.total_count ?? 0,
  };
};

export const deleteBasketItem = async (id: number): Promise<void> =>
  api.delete(`${basketAdminApiPrefix}/${id}`);
